(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-hero"] && !Shopify.designMode) return;
  try {
    
  // Figures only start counting once they are actually on screen, so a
  // visitor never lands on a number mid-tick.
  class CaviaCountUp {
    static init() {
      const targets = document.querySelectorAll('.cavia-eh__count:not([data-counted])');
      if (!targets.length) return;

      const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const run = (el) => {
        el.dataset.counted = '1';
        const to = parseFloat(el.dataset.countTo) || 0;
        if (calm) { el.textContent = to.toLocaleString(); return; }
        const dur = 1400;
        const start = performance.now();
        const step = (now) => {
          const p = Math.min(1, (now - start) / dur);
          // ease-out so it decelerates into the final figure
          const eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(to * eased).toLocaleString();
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            run(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });

      targets.forEach((el) => io.observe(el));
    }
  }

  document.addEventListener('DOMContentLoaded', () => CaviaCountUp.init());
  document.addEventListener('shopify:section:load', () => CaviaCountUp.init());
  CaviaCountUp.init();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class CaviaHeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.cavia-hs__slide')];
      if (this.slides.length === 0) return;

      this.dots = [...this.querySelectorAll('[data-hs-dot]')];
      this.index = 0;
      this.timer = null;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.interval = Math.max(2, parseInt(this.dataset.interval, 10) || 6) * 1000;

      this.show(0);

      if (this.slides.length < 2) return;

      this.querySelector('[data-hs-prev]')?.addEventListener('click', () => {
        this.show(this.index - 1);
        this.restart();
      });
      this.querySelector('[data-hs-next]')?.addEventListener('click', () => {
        this.show(this.index + 1);
        this.restart();
      });
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.show(parseInt(dot.dataset.hsDot, 10));
          this.restart();
        });
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      // Pausing off-screen keeps the timer from queueing transitions nobody sees.
      document.addEventListener('visibilitychange', () =>
        document.hidden ? this.stop() : this.start()
      );

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    show(next) {
      const total = this.slides.length;
      this.index = ((next % total) + total) % total;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.index);
        dot.setAttribute('aria-selected', i === this.index ? 'true' : 'false');
      });
    }

    start() {
      if (this.reduced || this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
      this.stop();
      this.timer = setInterval(() => this.show(this.index + 1), this.interval);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('cavia-hero-slideshow')) {
    customElements.define('cavia-hero-slideshow', CaviaHeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-utilities"] && !Shopify.designMode) return;
  try {
    
  class CaviaScrollUtils extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-progress-bar]');
      this.topButton = this.querySelector('[data-scroll-top]');
      this.scroller = this.findScroller();

      this.onScroll = this.onScroll.bind(this);
      /* Capture phase, because the scroll happens on an inner wrapper. */
      window.addEventListener('scroll', this.onScroll, true);
      window.addEventListener('resize', this.onScroll);

      if (this.topButton) {
        this.topButton.addEventListener('click', () => {
          const target = this.scroller || window;
          target.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }

      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll, true);
      window.removeEventListener('resize', this.onScroll);
    }

    /**
     * Returns the element that actually scrolls, or null when the window does.
     */
    findScroller() {
      const candidates = [document.querySelector('.page-wrapper')];

      let node = document.querySelector('#MainContent');
      while (node && node !== document.documentElement) {
        candidates.push(node);
        node = node.parentElement;
      }

      for (const element of candidates) {
        if (!element) continue;
        const overflow = getComputedStyle(element).overflowY;
        const scrolls = overflow === 'auto' || overflow === 'scroll';
        if (scrolls && element.scrollHeight > element.clientHeight + 4) return element;
      }

      return null;
    }

    readState() {
      if (this.scroller) {
        const total = this.scroller.scrollHeight - this.scroller.clientHeight;
        const current = this.scroller.scrollTop;
        return { current: current, progress: total > 0 ? current / total : 0 };
      }

      const total = document.documentElement.scrollHeight - window.innerHeight;
      const current = window.scrollY;
      return { current: current, progress: total > 0 ? current / total : 0 };
    }

    onScroll() {
      if (this.frame) return;
      this.frame = window.requestAnimationFrame(() => {
        this.frame = null;
        const state = this.readState();
        const progress = Math.min(1, Math.max(0, state.progress));

        if (this.bar) this.bar.style.transform = 'scaleX(' + progress + ')';
        if (this.topButton) this.topButton.hidden = state.current < window.innerHeight * 0.6;
      });
    }
  }

  if (!customElements.get('cavia-scroll-utils')) {
    customElements.define('cavia-scroll-utils', CaviaScrollUtils);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
  class CaviaScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-scroller]');
      if (!this.track) return;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-dir]');
        if (!button) return;
        const dir = parseInt(button.dataset.dir, 10) || 1;
        const first = this.track.firstElementChild;
        const step = first ? first.getBoundingClientRect().width + 12 : 300;
        this.track.scrollBy({ left: step * dir, behavior: 'smooth' });
      });
    }
  }

  if (!customElements.get('cavia-scroller')) {
    customElements.define('cavia-scroller', CaviaScroller);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-grid"] && !Shopify.designMode) return;
  try {
    
  class CaviaScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-scroller]');
      if (!this.track) return;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-dir]');
        if (!button) return;
        const dir = parseInt(button.dataset.dir, 10) || 1;
        const first = this.track.firstElementChild;
        const step = first ? first.getBoundingClientRect().width + 12 : 300;
        this.track.scrollBy({ left: step * dir, behavior: 'smooth' });
      });
    }
  }

  if (!customElements.get('cavia-scroller')) {
    customElements.define('cavia-scroller', CaviaScroller);
  }

  } catch(e) { console.error(e); }
})();
})();
